import AttachmentImageGallery from './AttachmentImageGallery'

export default function AiAskBarAttachmentGalleryOverlay({
  vm,
  attachmentGallerySenderLabel,
  attachmentGallerySubtitle,
  attachmentGallerySecondaryLine,
}) {
  return (
    <AttachmentImageGallery
      key={vm.attachmentGallerySession}
      open={vm.attachmentGalleryOpen && vm.imageAttachments.length > 0}
      onClose={() => vm.setAttachmentGalleryOpen(false)}
      items={vm.imageAttachments}
      initialIndex={vm.attachmentGalleryInitialIndex}
      senderLabel={attachmentGallerySenderLabel ?? 'You'}
      subtitle={attachmentGallerySubtitle}
      secondaryLine={attachmentGallerySecondaryLine}
    />
  )
}
